/* @ngInject */
const emailMetadata = (
  labels,
  emailLabels,
  emailFields,
  icons
) => {
  const self = {}

  self.fields = emailFields

  return self
}
export default emailMetadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/services/metadata.service.js